import { createAppAsyncThunk } from "domain/store.thunk";
import { OnBoardingState } from "domain/on-boarding/on-boarding.slice";

export const setOnBoardingValue = createAppAsyncThunk(
  "onBoarding/setOnBoardingValue",
  (body: { type: keyof OnBoardingState; value: boolean }) => {
    return body;
  }
);

export const setOnBoardingValues = createAppAsyncThunk(
  "onBoarding/setOnBoardingValues",
  (values: OnBoardingState) => {
    return values;
  }
);

export const closeOnBoarding = createAppAsyncThunk(
  "onBoarding/closeOnBoarding",
  (type: keyof OnBoardingState) => {
    return type;
  }
);
